import type { FaireProductEntity } from "../../entity_types/product";

export const p_9uqwm7u2k3: FaireProductEntity = {
  token: "p_9uqwm7u2k3",
  type: "product",
  name: "Lymphatic support body oil | Organic body serum",
  brandToken: "b_m3n7j6u3h2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/cb60d39432deca013aaffc08309decbaab5e6a3cb8223196c3688d617d8eb76b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b823218956576ff7671108f91c17e8a0a334312da2f2aef267a569797e90040c.png",
    "https://cdn.faire.com/fastly/2c57c1095c45c9a5a3c0030eccb3101e5d58e86ae4b999636d26f5f4a341eddc.png",
    "https://cdn.faire.com/fastly/1fd8b10b5d9e65696d9f721d4f6e8ddd7c7dde0892b4ec62e322e4f7c5862ada.png",
    "https://cdn.faire.com/fastly/56bbc709bd612c15832e42e64e973e3d074a70535e08716ea8012724ba23c5bd.png",
  ],
  priceDollars: 38.8,
  description:
    "Drench your skin in our herbal body serum to revive and radiate. A botanical blend of herbs and nutrient rich oils to help circulation, nourish, and sculpt the skin. Use with massage to promote lymphatic drainage. Best paired after dry brushing. (Dry brush sold separately). 4oz Amber glass bottle with pump\n\n✨Non toxic\n✨Fragrance free\n✨No hormone disruptors\n✨USDA certified herbs & oils\n\nSolar infused in small batches on Cape Cod, Ma. Woman owned, family run business.",
  tags: [],
  msrpDollars: 77.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:06.717Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
